import { StaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

// Note: You can change "images" to whatever you'd like.
function Image(props) {
    return (
        <StaticQuery
            query={graphql`
                {
                    allContentfulSiteImages(filter: { imageFile: { mimeType: { ne: "image/svg+xml" } } }) {
                        edges {
                            node {
                                id
                                name
                                imageFile {
                                    mimeType
                                    localFile {
                                        childImageSharp {
                                            fluid(
                                                maxWidth: 1920
                                                quality: 100
                                                srcSetBreakpoints: [400, 600, 960, 1280, 1920]
                                                toFormat: WEBP
                                            ) {
                                                ...GatsbyImageSharpFluid
                                                ...GatsbyImageSharpFluidLimitPresentationSize
                                                src
                                            }
                                            gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, formats: WEBP)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `}
            render={(data) => {
                const image = data.allContentfulSiteImages.edges.find((n) => n.node.name?.includes(props.name));
                if (!image) {
                    return <div>Image not found</div>;
                }

                const imageForOutput = image.node.imageFile.localFile?.childImageSharp.gatsbyImageData;

                // const imageSizes = image.node.childImageSharp.sizes; sizes={imageSizes}
                if (props.outputAsImgTag) {
                    return (
                        <img
                            src={image.node.imageFile.localFile?.childImageSharp.fluid.src}
                            alt={props.alt}
                            className={props.className}
                        />
                    );
                }
                return <GatsbyImage rel='preload' image={imageForOutput} alt={props.alt} className={props.className} />;
            }}
        />
    );
}

export default Image;
